<template>
	<v-card-item v-bind="{ ...props, title: translate(props.title) }">
		<template v-if="$slots.prepend" #prepend>
			<slot name="prepend"></slot>
		</template>
		<!-- TODO:: muss angepasst werden, die art und weise wie $props benutzt wird  -->
		<template #title v-if="$slots.title">
			<slot name="title" v-bind="{ title: props.title, titleClass }">
				<v-card-title :class="titleClass" data-test="card-title">
					{{ translate(title) }}
				</v-card-title>
			</slot>
		</template>

		<template #subtitle v-if="$slots.subtitle">
			<slot
				name="subtitle"
				v-bind="{ subtitle: $props.subtitle, subtitleClass }"
			>
				<v-card-subtitle :class="subtitleClass" data-test="card-subtitle">
					{{ subtitle }}
				</v-card-subtitle>
			</slot>
		</template>

		<template v-if="$slots.append || closeBtn" #append>
			<slot name="append">
				<v-btn
					v-if="closeBtn"
					icon="$close"
					variant="text"
					@click="$emit('close')"
				></v-btn>
			</slot>
		</template>
	</v-card-item>
</template>

<script setup lang="ts">
import type { CardPropsTitle } from 'templates/Card/CardProps.ts'
import { useTranslate } from 'composables/useTranslate.ts'

const { translate } = useTranslate()
const props = defineProps<CardPropsTitle>()

defineEmits(['close'])
</script>

<style scoped></style>
